(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('agendaLabelTranslationTable', ['$rootScope','ItemTableService', AgendaLabelTranslationTableDirectiveFn]);

    function AgendaLabelTranslationTableDirectiveFn($rootScope,ItemTableService) {

        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/agendasettings/templates/agenda-label-translation-table.template.html',
            scope: {
                translations: '=',
                languages: '=',
                new: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.isRingfoon = $rootScope.isRingfoon;

            // table status -> to proof if table is in edit mode ?
            scope.status = false;
            // only the active ones
            scope.filterShowAll = false;

            // functions
            scope.add = add;


            activate();

            // activation work
            function activate() {
                // init translation list
                ItemTableService.init(scope.translations, scope.languages);

                // link to variable for show
                scope.translations = ItemTableService.list();

                // status of table
                scope.status = ItemTableService.data;

                // if new => immediately add a new item
                if (scope.new) {
                    add();
                }
            }


            // add new row to table
            function add() {
                ItemTableService.add();
                scope.languages = ItemTableService.languageList();
            }


        }
    }

})();